// extracted by mini-css-extract-plugin
export default {"images-stack":"_1qrqqo9","imagesStack":"_1qrqqo9","icon":"_xtjklr"};